import * as React from 'react';
import configData from "../config.json";
import logo from "../assets/greylogo.png";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { GetSession } from '../components/Session';

export const WeighbridgeHeader = (props) => {
    const [dateTime, setDateTime] = React.useState("");
    const version = configData.VERSION;
    const versionDate = configData.VERSION_DATE;
    const [docketHead, setDocketHead] = React.useState("");
    const [docketNo, setDocketNo] = React.useState("");
    const [showDlg, setShowDlg] = React.useState(false);
    const site = props.site;

    const timeInterval = React.useRef(null);
    if (props.docketNo !== ""  && (docketHead + ":" + docketNo !== props.docketNo)) {
        let s = String(props.docketNo).split(":");
        setDocketHead(s[0]);
        setDocketNo(s.length > 1 ? s[1] : "");
    }

    React.useEffect(() => {
        UpdateTime();
        timeInterval.current = setInterval(() => UpdateTime(), 10000);
        return () => {
            if (timeInterval.current !== null) clearInterval(timeInterval.current);
        }
    }, []);

    const UpdateTime = () => {
        let dt = new Date();
        let hr = dt.getHours() % 12;
        if (hr === 0) hr = 12;
        setDateTime(dt.getDate() + "/" + (dt.getMonth() + 1) + "/" + (dt.getFullYear() % 100) + " " + hr + ":" + (dt.getMinutes() < 10 ? "0" : "") + dt.getMinutes());
    }

    const ShowSiteInfo = () => {
        setShowDlg(true);
    }

    return (
        <div>
            <div className="weighbridgeInfo">
                {props.showLogo && <div id="WeighbridgeTitle"><div className="SiteTitle">
                    <img src={logo} alt="EZYweigh" />
                </div><div style={{ "textAlign": "center" }}>NMI S627</div></div>}
                <div className="weighbridgeInfoTime">{dateTime}</div>
                <div className="weighbridgeInfoVersion" onClick={ShowSiteInfo}>{version}</div>
                <div className="weighbridgeInfoVersionDate">{versionDate}</div>
                <div className="weighbridgeDocketHead">{docketHead}</div>
                <div className="weighbridgeDocket">{docketNo}</div>
            </div>
            {showDlg && <Dialog title="System Information" onClose={() => setShowDlg(false)}>
                <div class="row">
                    <div class="col-md-2">Site</div>
                    <div class="col-md-10">{site.name}</div>
                </div>
                <div class="row">
                    <div class="col-md-2">Operator</div>
                    <div class="col-md-10">{GetSession().UserName}</div>
                </div>
                <div class="row">
                    <div class="col-md-2">Server</div>
                    <div class="col-md-10">{GetSession().CloudURL}</div>
                </div>
                <DialogActionsBar ><div style={{ textAlign: "center" }}>
                    <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base bigButton acceptButton" onClick={() => setShowDlg(false)}>Ok</button>
                </div>
                </DialogActionsBar>
            </Dialog>}

        </div>
    );
}

export default WeighbridgeHeader;
